// 現在の軍資金 B がどのゾーンにいるかの判定（§9）。B は判定表示のみ（§5.1）。
// 引数は全て同一単位（base）で渡す。判定・段階ハイライトは単位不変。
export type Zone = 'safe' | 'warn' | 'danger' | 'neutral';

export interface Verdict {
  zone: Zone;
  /** B 以上を満たす最上位段階（ハイライト対象）。 */
  activeTier: 'full' | 'half' | 'quarter' | null;
  text: string;
}

export function judge(
  bankFull: number,
  bankHalf: number,
  bankQuarter: number,
  C: number,
  bankroll: number | null | undefined,
): Verdict {
  if (bankroll == null || Number.isNaN(bankroll)) {
    return { zone: 'neutral', activeTier: null, text: '現在の軍資金を入れると、どのゾーンにいるかを判定します。' };
  }
  if (bankroll < C) {
    return { zone: 'danger', activeTier: null, text: 'コスト1周分すら払えません。まずは元手を増やしましょう。' };
  }
  if (bankroll >= bankQuarter) {
    return {
      zone: 'safe',
      activeTier: 'quarter',
      text: '慎重圏。クォーターケリー以上で、破産リスクはほぼありません。腰を据えて回せます。',
    };
  }
  if (bankroll >= bankHalf) {
    return {
      zone: 'safe',
      activeTier: 'half',
      text: '標準圏。ハーフケリーを満たしています。見積り誤差を吸収しつつ着実に増やせるラインです。',
    };
  }
  if (bankroll >= bankFull) {
    return {
      zone: 'warn',
      activeTier: 'full',
      text: '攻め圏。フルケリー以上ですが、ドロップ率や相場の見積り誤差に過敏です。少し賭けすぎ寄り。',
    };
  }
  return {
    zone: 'danger',
    activeTier: null,
    text: '賭けすぎゾーン。フルケリーにも届かず、不運が続くと資金が尽きる確率が高いです。',
  };
}
